import { z } from 'zod';

export const nameSchema = z.string().min(3, 'Name must be at least 3 characters long.');

export function isContactFilled(c: { first_name: string; last_name: string; email: string; phone: string }): boolean {
  return !!(c.first_name.trim() || c.last_name.trim() || c.email.trim() || c.phone.trim());
}

export function splitFullName(fullName: string): { first: string; last: string } {
  const idx = fullName.indexOf(' ');
  if (idx === -1) return { first: fullName, last: '' };
  return { first: fullName.slice(0, idx), last: fullName.slice(idx + 1) };
}
